import type { WebSocketClient } from './web-socket-client';

export class WebSocketPublisher {
    private sender: (<T>(action: string, data: T) => Promise<void>) | undefined = undefined;

    connect(webSocketClient: WebSocketClient): void {
        this.sender = (action, data) => webSocketClient.send(action, data);
    }

    disconnect(): void {
        this.sender = undefined;
    }

    async publish<T>(action: string, data: T): Promise<void> {
        if (!this.sender) {
            throw new Error('WebSocketPublisher is not connected to a WebSocketClient');
        }
        await this.sender(action, data);
    }
}

export const webSocketPublisher = new WebSocketPublisher();
